import React from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Grid from '@mui/material/Grid2'
import defaultTexts from '../../../texts/texts'
import CustomSwitchField from '../../_common/_form_fields/CustomSwitchField'
import CustomCheckboxField from '../../_common/_form_fields/CustomCheckboxField'

const PermissionsEdit = (props) => {
  const { billingPermissions, setBillingPermissions, getDefaultBillingPermissions } = props
  const theme = useTheme()

  const fieldBoxStyle = {
    padding: '12px 0px'
  }

  const switchLabelStyle = {
    color: theme.palette.oxfordBlue,
    fontSize: '16px',
    fontWeight: '500',
  }

  const checkboxStyle = {
    color: theme.palette.violetsAreBlue,

    '&.Mui-checked': {
      color: theme.palette.violetsAreBlue,
    },

    '& .MuiSvgIcon-root': {
      fontSize: 24,
    },
  }

  const checkboxLabelStyle = {
    color: theme.palette.oxfordBlue,
    fontSize: '16px',
  }

  const isAllowManagement = () => {
    return billingPermissions && billingPermissions.config_params && billingPermissions.config_params.visible_to_service && billingPermissions.config_params.visible_to_service.length > 0 && billingPermissions.config_params.visible_to_service.includes('custom_admin_ui')
  }

  const isPermission = (section, permission) => {
    let result = false

    if (billingPermissions && billingPermissions.config_params && billingPermissions.config_params.custom_admin_ui && billingPermissions.config_params.custom_admin_ui.length > 0) {
      const section_object = billingPermissions.config_params.custom_admin_ui.find(item => item.section === section)
      if (section_object && section_object.permissions && section_object.permissions.length > 0 && section_object.permissions.includes(permission)) {
        result = true
      }
    }

    return result
  }
  
  const updatePermission = (section, permission, value) => {
    setBillingPermissions(prev => {
      let updated_custom_admin_ui = []
      
      prev.config_params.custom_admin_ui.forEach(s => {
        if (s.section === section) {
          let updated_permissions = []

          if (value) {
            updated_permissions = [...s.permissions, permission]
          } else {
            updated_permissions = s.permissions.filter(p => p !== permission)
          }

          updated_custom_admin_ui.push({ ...s, permissions: updated_permissions })
        } else {
          updated_custom_admin_ui.push(s)
        }
      })

      return {
        ...prev,
        config_params: {
          visible_to_service: prev.config_params.visible_to_service,
          custom_admin_ui: updated_custom_admin_ui,
        },        
      }
    })
  }
  
  const handleChangeAllowManagement = (event) => {
    const value = event.target.checked

    if (value) {
      setBillingPermissions(getDefaultBillingPermissions())
    } else {
      setBillingPermissions({
        visible_to_service: ['custom_client_ui'],
        custom_admin_ui: [],
      })
    }
  }

  const handleChangeConfigsRead = (value) => {
    updatePermission('billing_configs', 'read', value)
  }

  const handleChangeAnalyticsRead = (value) => {
    updatePermission('billing_analytics', 'read', value)
  }

  const handleChangeDepositsRead = (value) => {
    updatePermission('billing_deposits', 'read', value)
  }

  const handleChangeDepositsUpdate = (value) => {
    updatePermission('billing_deposits', 'update', value)
  }

  const handleChangeServicesRead = (value) => {
    updatePermission('billing_services', 'read', value)
  }

  const handleChangeServicesCreate = (value) => {
    updatePermission('billing_services', 'create', value)
  }

  const handleChangeServicesUpdate = (value) => {
    updatePermission('billing_services', 'update', value)
  }

  const handleChangeServicesDelete = (value) => {
    updatePermission('billing_services', 'delete', value)
  }

  const handleChangePricesRead = (value) => {
    updatePermission('billing_prices', 'read', value)
  }

  const handleChangePricesUpdate = (value) => {
    updatePermission('billing_prices', 'update', value)
  }

  const handleChangePricesCreate = (value) => {
    updatePermission('billing_prices', 'create', value)
  }
  
  return (
    <>
      <Box sx={fieldBoxStyle}>
        <Stack
          direction='row'
          justifyContent='center'
        >
          <CustomSwitchField
            label={defaultTexts.allowBillingManagementText}
            checked={isAllowManagement()}
            handleChange={handleChangeAllowManagement}
            sxLabel={switchLabelStyle}
          />
        </Stack>
      </Box>

      {
        isAllowManagement() &&
        <Grid container>
          <Grid size={{ lg: 4 }}>

            <Box>
              <CustomCheckboxField
                label={defaultTexts.displayBillingServiceConfiguration}
                checked={isPermission('billing_configs', 'read')}
                handleChange={handleChangeConfigsRead}
                sx={checkboxStyle}
                sxLabel={checkboxLabelStyle}
              />
            </Box>

            <Box>
              <CustomCheckboxField
                label={defaultTexts.displayBillingServiceAnalytics}
                checked={isPermission('billing_analytics', 'read')}
                handleChange={handleChangeAnalyticsRead}
                sx={checkboxStyle}
                sxLabel={checkboxLabelStyle}
              />
            </Box>

            <Box>
              <CustomCheckboxField
                label={defaultTexts.displayUserAccounts}
                checked={isPermission('billing_deposits', 'read')}
                handleChange={handleChangeDepositsRead}
                sx={checkboxStyle}
                sxLabel={checkboxLabelStyle}
              />
            </Box>

            <Box>
              <CustomCheckboxField
                label={defaultTexts.updateUserAccounts}
                checked={isPermission('billing_deposits', 'update')}
                handleChange={handleChangeDepositsUpdate}
                sx={checkboxStyle}
                sxLabel={checkboxLabelStyle}
              />
            </Box>

          </Grid>
          <Grid size={{ lg: 5 }}>

            <Box>
              <CustomCheckboxField
                label={defaultTexts.displayOpenStackServiceConfiguration}
                checked={isPermission('billing_services', 'read')}
                handleChange={handleChangeServicesRead}
                sx={checkboxStyle}
                sxLabel={checkboxLabelStyle}
              />
            </Box>

            <Box>
              <CustomCheckboxField
                label={defaultTexts.addNewOpenStackServiceToBilling}
                checked={isPermission('billing_services', 'create')}
                handleChange={handleChangeServicesCreate}
                sx={checkboxStyle}
                sxLabel={checkboxLabelStyle}
              />
            </Box>

            <Box>
              <CustomCheckboxField
                label={defaultTexts.updateOpenStackServiceConfiguration}
                checked={isPermission('billing_services', 'update')}
                handleChange={handleChangeServicesUpdate}
                sx={checkboxStyle}
                sxLabel={checkboxLabelStyle}
              />
            </Box>

            <Box>
              <CustomCheckboxField
                label={defaultTexts.deleteOpenStackServiceFromBilling}
                checked={isPermission('billing_services', 'delete')}
                handleChange={handleChangeServicesDelete}
                sx={checkboxStyle}
                sxLabel={checkboxLabelStyle}
              />
            </Box>

          </Grid>
          <Grid size={{ lg: 3 }}>

            <Box>
              <CustomCheckboxField
                label={defaultTexts.displayPrices}
                checked={isPermission('billing_prices', 'read')}
                handleChange={handleChangePricesRead}
                sx={checkboxStyle}
                sxLabel={checkboxLabelStyle}
              />
            </Box>

            <Box>
              <CustomCheckboxField
                label={defaultTexts.updatePrices}
                checked={isPermission('billing_prices', 'update')}
                handleChange={handleChangePricesUpdate}
                sx={checkboxStyle}
                sxLabel={checkboxLabelStyle}
              />
            </Box>

            <Box>
              <CustomCheckboxField
                label={defaultTexts.addNewPrices}
                checked={isPermission('billing_prices', 'create')}
                handleChange={handleChangePricesCreate}
                sx={checkboxStyle}
                sxLabel={checkboxLabelStyle}
              />
            </Box>

          </Grid>
        </Grid>
      }
    </>
  )
}

export default PermissionsEdit